import { render, staticRenderFns } from "./CancellationReasonsDictionary.vue?vue&type=template&id=4b59668f&lang=pug&"
import script from "./CancellationReasonsDictionary.vue?vue&type=script&lang=js&"
export * from "./CancellationReasonsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports